import React, { Component } from 'react';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';
class ForgetPassword extends Component {
	state = {
		isEmail: true,
	};
	render() {
		return (
			<>
				<div className='container-fluid pt-3'>
					<div className='d-flex align-items-center'>
						<h2 className='font-weight-bold text-uppercase'>
							Registration
						</h2>
					</div>
					<hr />
					<div
						className={`mt-5 ${
							!this.state.isEmail ? 'd-none' : ''
						}`}
					>
						<h5 className='font-weight-bold'>Forgot Password?</h5>
						<p className='mt-2'>
							Please enter your email address to reset the
							password
						</p>
						<Row>
							<Col lg='6' xl='4'>
								<FormGroup className='mt-4'>
									<Label>Email</Label>
									<Input className='custom-form-control'></Input>
								</FormGroup>
								<Button
									className='btn-outline mr-5 mt-3 dashboard-btn'
									onClick={e =>
										this.setState({ isEmail: false })
									}
								>
									rest password
								</Button>
								<div className='d-flex mt-3'>
									Need help?{' '}
									<a className='ml-1' href=''>
										Contact us
									</a>
								</div>
							</Col>
						</Row>
					</div>
					<div
						className={`mt-5 ${this.state.isEmail ? 'd-none' : ''}`}
					>
						<h5 className='font-weight-bold'>Forgot Password?</h5>
						<p className='mt-2'>
							Please enter your email address to reset the
							password
						</p>
						<Row>
							<Col lg='6' xl='4'>
								<FormGroup className='mt-4'>
									<Label>Password</Label>
									<Input className='custom-form-control'></Input>
								</FormGroup>
								<FormGroup className='mt-4'>
									<Label>Confirm Password</Label>
									<Input className='custom-form-control'></Input>
								</FormGroup>
								<Button
									className='btn-outline mr-5 mt-3 dashboard-btn'
									onClick={e =>
										this.setState({ isEmail: false })
									}
								>
									done
								</Button>
								<div className='d-flex mt-3'>
									Need help?{' '}
									<a className='ml-1' href=''>
										Contact us
									</a>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</>
		);
	}
}

export default ForgetPassword;
